module.exports = __webpack_public_path__ + "img/logo_ses-rs.322d32fe.svg";